(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7828],{

/***/ 80222:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./cs/common.json": 58891,
	"./en/common.json": 4807,
	"./pl/common.json": 65978,
	"./sk/common.json": 86939,
	"./uk/common.json": 95872
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80222;

/***/ }),

/***/ 7427:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./cs/seo.json": 43328,
	"./en/seo.json": 52540,
	"./pl/seo.json": 52729,
	"./sk/seo.json": 96704,
	"./uk/seo.json": 80983
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7427;

/***/ }),

/***/ 51946:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/playlist/[slug]",
      function () {
        return __webpack_require__(39148);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2297:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(84911);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var components_DramoxImage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20010);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62044);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56168);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52662);
/* harmony import */ var _enums_namespaces__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99731);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17651);
/* harmony import */ var _typings_api__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(81962);
/* harmony import */ var _AppLink_AppLink__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3245);
/* harmony import */ var _Select_Select__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53173);











var SortType;
(function(SortType) {
    SortType["DateDesc"] = "dateAsc";
    SortType["DateAsc"] = "dateDesc";
    SortType["Alpha"] = "alphabeticallyDesc";
})(SortType || (SortType = {}));
var CategorySectionPlaylist = function(param) {
    var headline = param.headline, plays = param.plays, index = param.index, _isSortable = param.isSortable, isSortable = _isSortable === void 0 ? false : _isSortable, _emptyState = param.emptyState, emptyState = _emptyState === void 0 ? false : _emptyState;
    var ref = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_enums_namespaces__WEBPACK_IMPORTED_MODULE_5__/* .Namespace.Common */ .l.Common), lang = ref.lang, t = ref.t;
    var user = (0,_context__WEBPACK_IMPORTED_MODULE_4__/* .useAuth */ .aC)().user;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]), sortedPlays = ref1[0], setSortedPlays = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        onSortChange(SortType.DateDesc);
    }, []);
    var onSortChange = function(sort) {
        var tempPlays = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(plays);
        if (sort === SortType.Alpha) {
            tempPlays.sort(function(a, b) {
                return a.title.localeCompare(b.title);
            });
            setSortedPlays(tempPlays);
        } else if (sort === SortType.DateAsc || sort === SortType.DateDesc) {
            tempPlays.sort(function(a, b) {
                var first = new Date(a.watchlist_added);
                var second = new Date(b.watchlist_added);
                if (first.getTime() < second.getTime()) {
                    return sort === SortType.DateAsc ? -1 : 1;
                } else if (first.getTime() > second.getTime()) {
                    return sort === SortType.DateAsc ? 1 : -1;
                } else {
                    return 0;
                }
            });
            setSortedPlays(tempPlays);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "category-section category-playlist ".concat(!index || index === 0 ? "first" : ""),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "play-list-wrapper ".concat(isSortable ? "with-sort" : ""),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "sort-wrapper",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            children: headline
                        }),
                        isSortable ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "sort-option ",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    children: [
                                        t("sort_from"),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Select_Select__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                    className: "sort-select",
                                    name: "",
                                    onChange: function(val) {
                                        onSortChange(val);
                                    },
                                    options: [
                                        {
                                            value: SortType.DateDesc,
                                            label: "".concat(t("sort_date_desc"))
                                        },
                                        {
                                            value: SortType.DateAsc,
                                            label: "".concat(t("sort_date_asc"))
                                        },
                                        {
                                            value: SortType.Alpha,
                                            label: "".concat(t("sort_alphabetically_desc"))
                                        }, 
                                    ],
                                    defaultValue: SortType.DateDesc
                                })
                            ]
                        }) : null
                    ]
                }),
                (plays === null || plays === void 0 ? void 0 : plays.length) === 0 && emptyState ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "empty-list",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "icon"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            children: t("add_first_play")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: t("how_add")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            href: _helpers__WEBPACK_IMPORTED_MODULE_6__/* .Permalink.root */ .xm.root(user, lang),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: t("check_library")
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                    className: "play-list",
                    children: sortedPlays === null || sortedPlays === void 0 ? void 0 : sortedPlays.map(function(play, i) {
                        var ref;
                        // onClick={() => playsGEvent(item.permalink)}
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                href: _helpers__WEBPACK_IMPORTED_MODULE_6__/* .Permalink.play */ .xm.play(play, lang),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                    tabIndex: -1,
                                    children: [
                                        play.state === _typings_api__WEBPACK_IMPORTED_MODULE_7__/* .PlayState.PROMOTED */ .QT.PROMOTED ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "coming-soon",
                                            children: t("coming_soon")
                                        }) : null,
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_DramoxImage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                            placeholderClass: "image-wrapper-for-playlist",
                                            src: play.poster_url,
                                            alt: play.title,
                                            width: 256,
                                            height: 144,
                                            quality: 90
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                    children: (0,_helpers__WEBPACK_IMPORTED_MODULE_6__/* .truncateTitle */ .ew)(play.title)
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    children: play === null || play === void 0 ? void 0 : (ref = play.theatre) === null || ref === void 0 ? void 0 : ref.name
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }, i);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CategorySectionPlaylist);


/***/ }),

/***/ 86982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var context_authContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13102);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17651);
/* harmony import */ var helpers_jsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28808);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62044);
/* harmony import */ var next_translate_I18nProvider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67014);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1984);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _components_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3245);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(46323);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(96168);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(57919);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(i18n__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(75332);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(56168);

// @ts-ignore












var i18n = i18n__WEBPACK_IMPORTED_MODULE_9__.locales.map(function(l) {
    return {
        locale: l,
        common: __webpack_require__(80222)("./".concat(l, "/common.json")),
        seo: __webpack_require__(7427)("./".concat(l, "/seo.json"))
    };
});
var Content = function(param) {
    var countryCode = param.countryCode, locale = param.locale;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().t;
    var user = (0,context_authContext__WEBPACK_IMPORTED_MODULE_1__/* .useAuth */ .aC)().user;
    var asPath = (0,next_router__WEBPACK_IMPORTED_MODULE_10__.useRouter)().asPath;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_11__.useMemo)(function() {
        var t = "common:not_found.title";
        var desc = "common:not_found.description";
        if ((0,helpers__WEBPACK_IMPORTED_MODULE_2__/* .isPerformanceRoute */ .rQ)(asPath)) {
            t = "common:performance_not_found.title";
            desc = "common:performance_not_found.description";
        }
        return [
            t,
            desc
        ];
    }, [
        asPath
    ]), title = ref[0], description = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Layout__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        countryCode: countryCode,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_6___default()), {
                children: (0,helpers_jsx__WEBPACK_IMPORTED_MODULE_3__/* .basicSEO */ .F)(t("seo:404_title"), t("seo:404_description"))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().notFound),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "section-wrapper",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "heading",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                children: t(title)
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: t(description)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            href: helpers__WEBPACK_IMPORTED_MODULE_2__/* .Permalink.root */ .xm.root(user, locale),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "btn btn-primary",
                                children: t("common:not_found.btn")
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var Page404 = function() {
    var ref = (0,context_authContext__WEBPACK_IMPORTED_MODULE_1__/* .useAuth */ .aC)(), locale = ref.locale, isUserLoaded = ref.isUserLoaded, user = ref.user;
    if (!isUserLoaded) {
        return null;
    }
    var ref1;
    var _locale = (ref1 = user === null || user === void 0 ? void 0 : user.language) !== null && ref1 !== void 0 ? ref1 : (0,helpers__WEBPACK_IMPORTED_MODULE_2__/* .localeFromHost */ .Op)(window.location.host);
    var countryCode = (0,helpers__WEBPACK_IMPORTED_MODULE_2__/* .countryFromHost */ ._P)(window.location.host);
    var ref2;
    var ref3 = (ref2 = i18n.find(function(c) {
        return c.locale === _locale;
    })) !== null && ref2 !== void 0 ? ref2 : {}, common = ref3.common, seo = ref3.seo;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_translate_I18nProvider__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        lang: _locale,
        namespaces: {
            common: common,
            seo: seo
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Content, {
            countryCode: countryCode,
            locale: _locale
        })
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Page404);


/***/ }),

/***/ 39148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56168);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1984);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52662);
/* harmony import */ var helpers_jsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28808);
/* harmony import */ var pages_404__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86982);
/* harmony import */ var _components_CategorySections_CategorySectionPlaylist__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2297);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46323);

// @ts-ignore







var Playlist = function(param) {
    var section = param.section, headline = param.headline, description = param.description, countryCode = param.countryCode, canonical = param.canonical;
    if (!section) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pages_404__WEBPACK_IMPORTED_MODULE_5__["default"], {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Layout__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        countryCode: countryCode,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: (0,helpers_jsx__WEBPACK_IMPORTED_MODULE_4__/* .basicSEO */ .F)(section === null || section === void 0 ? void 0 : section.name, description, undefined, undefined, true, canonical)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CategorySections_CategorySectionPlaylist__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                headline: headline,
                plays: section === null || section === void 0 ? void 0 : section.plays
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = ((0,context__WEBPACK_IMPORTED_MODULE_3__/* .withForcePlanToLoggedInUnsubs */ .DE)(Playlist));


/***/ }),

/***/ 96168:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"notFound":"__404_notFound___KiOk"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(51946); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);